const environment = {
  appVersion: "3.19.25",
  googleMapsLibraries: ["places"],
};

export default environment;
